var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#0055FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0002 48.3999L27.0002 41.3999C26.2202 40.6199 24.9802 40.6199 24.2002 41.3999C23.4202 42.1799 23.4202 43.4199 24.2002 44.1999L32.5802 52.5799C33.3602 53.3599 34.6202 53.3599 35.4002 52.5799L56.6002 31.3999C57.3802 30.6199 57.3802 29.3799 56.6002 28.5999C55.8202 27.8199 54.5802 27.8199 53.8002 28.5999L34.0002 48.3999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.98df86f0fe32bf629769be98ee47622e.svg";
export { ForwardRef as ReactComponent };